import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const insights = [
  {
    image: 'https://public.readdy.ai/ai/img_res/04dd62ca4d2a6ca03cbe6c57fd289e64.jpg',
    title: '2025 Las Vegas Visitor Statistics Report: Impact on Billboard Advertising',
    description: 'Updated tourism data and how rising visitor numbers influence billboard advertising ROI in Las Vegas.',
    date: 'February 15, 2026',
    category: 'Market Analysis',
    link: '/en/blog/las-vegas-visitor-statistics-2025',
    bgColor: 'bg-blue-50',
    buttonStyle: 'bg-black text-white',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Outdoor%20advertising%20industry%20trends%20visualization%20with%20modern%20graphics%2C%20OOH%20marketing%20analysis%20with%20clean%20design%2C%20professional%20business%20presentation%20style%2C%20neutral%20gray%20background%2C%20contemporary%20infographic%20aesthetic&width=600&height=400&seq=insight-ooh-trends-002&orientation=landscape',
    title: 'Las Vegas OOH Advertising Trends 2025: Digital Billboard Market Analysis',
    description: 'A deep dive into outdoor advertising trends, digital billboard growth, and performance metrics across Las Vegas.',
    date: 'February 10, 2026',
    category: 'Industry Trends',
    link: '/en/blog/las-vegas-ooh-advertising-trends-2025',
    bgColor: 'bg-gray-50',
    buttonStyle: 'bg-white border-2 border-black text-black',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Real%20estate%20investment%20strategy%20illustration%20with%20warm%20beige%20tones%2C%20financial%20planning%20concept%20with%20clean%20minimalist%20design%2C%20professional%20investment%20advisory%20aesthetic%2C%20simple%20neutral%20background%2C%20modern%20business%20style&width=600&height=400&seq=insight-investment-column-003&orientation=landscape',
    title: 'Billboard Investment in Las Vegas: Tax Benefits and ROI Strategy Guide',
    description: 'How billboard investment works, expected ROI, depreciation benefits, and long-term asset strategies.',
    date: 'February 5, 2026',
    category: 'Investment Insights',
    link: '/en/blog/billboard-investment-tax-benefits-guide',
    bgColor: 'bg-amber-50',
    buttonStyle: 'bg-white border-2 border-black text-black',
  },
];

export default function LatestInsights() {
  return (
    <section className="py-14 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-black">
            Latest Insights
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {insights.map((insight, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group cursor-pointer"
            >
              <Link to={insight.link} className="block no-underline">
                <div className={`rounded-md overflow-hidden ${insight.bgColor} p-4`}>
                  <div className="w-full h-40 rounded-sm overflow-hidden mb-4">
                    <img
                      src={insight.image}
                      alt={insight.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <h3 className="text-base font-bold text-black text-center mb-2 leading-snug">
                    {insight.title}
                  </h3>
                  <p className="text-xs text-gray-500 text-center mb-3 leading-relaxed">
                    {insight.description}
                  </p>
                  <p className="text-xs text-gray-600 text-center mb-4">
                    {insight.date}
                  </p>
                  <div className="flex justify-center mb-3">
                    <span className={`px-5 py-2 rounded-full font-medium text-xs transition-all whitespace-nowrap ${insight.buttonStyle}`}>
                      Read More
                    </span>
                  </div>
                  <p className="text-xs text-gray-500 text-center">
                    {insight.category}
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
